// Other Actions → "Message the customer" (2026-10-27; docs/contact-view.md).
// The server builds the client's contact step (routes/ai.js's manual-actions
// route, actions.js's messageCustomerSteps()): an eBay message to the buyer,
// or the email for the reply box (Website, Walmart). Pure helpers, unit
// tested in ui/test/messageCustomer.test.js.

import { templateHtmlToPlainText } from '@cxhub/shared'

// What the modal shows for a built step: 'ebay' (an editable message and a
// template picker, Process sends it), 'email' (the text goes into the reply
// box, Send sends it), or 'review' (a reason, nothing to do here).
export function messageCustomerKind(action) {
  if (action?.type === 'sales_hold_send_ebay_message') return 'ebay'
  if (action?.type === 'message_customer_email') return 'email'
  return 'review'
}

// A picked template as the eBay message: the template's plain text, the
// address on file in INSERTADDRESS, and the signature the step carries.
export function messageFromTemplate(content, { addressBlock = null, signature = null } = {}) {
  let text = templateHtmlToPlainText(String(content ?? '')).trim()
  if (addressBlock && text.includes('INSERTADDRESS')) text = text.replace('INSERTADDRESS', addressBlock)
  return signature ? `${text}\n\n${signature}` : text
}

// The picker's options: the client's eBay folders, grouped by folder, in
// folder then title order.
export function templatePickerOptions(options = []) {
  return [...(options ?? [])]
    .filter((o) => o?.id && o?.title)
    .sort((a, b) => String(a.folder ?? '').localeCompare(String(b.folder ?? '')) || String(a.title).localeCompare(String(b.title)))
}
